import { React, useState } from "react"
import IFrameResizer from "iframe-resizer-react"

export default function Vacancy() {  
  const [loaded, setLoaded] = useState(false);

  const onLoad = () => {
    setLoaded(true);
  };

  return (
    <div className="vacancy-area text-card">
      <h2 className="span-all-columns h2-responsive mb-0">Vacancies</h2>
      <IFrameResizer
        title="vacancy-iframe"
        id="elmo-recruitment-embed"
        src="https://cashconverters.elmotalent.co.nz/careers/careers/jobs?layout=iframe"
        checkOrigin={false}
        style={{
          display: loaded ? 'block' : 'none',
          width: '100%',
          overflow: 'hidden',
          border:  '0px none'
        }}
        scrolling="no"
        onLoad={onLoad}
      />
    </div>
  )
}